/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon16Light = forwardRef('ArrowDCornerDownRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 10A2.5 2.5 0 0 1 2 7.5v-6a.5.5 0 0 1 1 0v6A1.5 1.5 0 0 0 4.5 9h8.293L9.146 5.354a.5.5 0 1 1 .708-.708l3.651 3.652a1.7 1.7 0 0 1 0 2.404l-3.651 3.652a.5.5 0 0 1-.708-.708L12.793 10H4.5Z" })));
});
